/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Glyph } from 'kepler';
import { connect } from 'react-redux';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import getHistory from '../../lib/HistoryHelper';
import { trackLink } from '../../lib/analytics-helper';
import getPageUrlInfoFromLocation from '../../lib/location-helper';
import urlResource from '../constants/UrlResources';

const TopicList = (props) => {
  const { location, topics, isLoading, error, article, breadcrumb } = props;
  const exp = Page.getUserExperience();
  const history = getHistory();
  const popular = {
    common: i18n.message('smarthelp/home.home.common'),
    recommended: i18n.message('smarthelp/home.home.recommended'),
  };
  const pg = getPageUrlInfoFromLocation(location);
  const popularlabel = (Page.isLoggedIn() ? popular.recommended : popular.common);

  const popularClass = classNames({
    'topic-tree-elements': true,
    'topic-selected': (pg.resource.name === urlResource.HOME),
  });

  const parentTopic = (currentArticle, breadcrumbs) => {
    if (Array.isArray(breadcrumbs) && breadcrumbs[1]) {
      return breadcrumbs[1].id;
    } else if (currentArticle && currentArticle.breadCrumbPath) {
      const topicTree = currentArticle.breadCrumbPath.split('/');
      return topicTree[1];
    }
    return null;
  };

  const goToHome = () => {
    trackLink({ id: 'homePage', link: 'smarthelp-home-page|common-questions' });
    history.push(`/${exp}/home`);
  };
  const goToTopicList = (topic) => {
    trackLink({ id: 'topicPage', link: `smarthelp-topic-page|${topic.topicId}` });
    history.push(`/${exp}/topic/${topic.topicId}`);
  };

  const getTopicClass = (topic) => {
    if (pg.resource.name === urlResource.HOME || Page.isMobileLayout()) {
      return 'topic-tree-elements';
    } else if (pg.resource.name === urlResource.TOPIC && String(topic.topicId) === pg.resource.id) {
      return 'topic-tree-elements topic-selected';
    } else if (pg.resource.name === urlResource.ARTICLE && parentTopic(article, breadcrumb) === String(topic.topicId)) {
      return 'topic-tree-elements topic-selected';
    }
    return 'topic-tree-elements';
  };
  const handleKeyPress = (e) => {
    if (e.which === 13) {
      goToHome();
    }
  };
  const handleKeyPressForTopics = (e, topic) => {
    if (e.which === 13) {
      goToTopicList(topic);
    }
  };
  const getCommonQuestions = () => {
    if (!Page.isMobileLayout()) {
      return (<li
        className={popularClass}
        role="button"
        tabIndex="0"
        onClick={() => goToHome()}
        onKeyPress={event => handleKeyPress(event)}
      >
        {popularlabel}
      </li>);
    }
    return null;
  };

  const getTopicList = () => topics.map(topic =>
    <li
      className={getTopicClass(topic)}
      tabIndex="0"
      role="button"
      key={topic.topicId}
      onClick={() => goToTopicList(topic)}
      onKeyPress={event => handleKeyPressForTopics(event, topic)}
    >
      {topic.topicName}
      <Glyph icon="icon-arrow-right-small" className="icon-arrow" />
    </li>);

  const renderTopicTree = () => {
    if (!isLoading && !error) {
      return (
        <ul className="topic-tree-container-home">
          {getCommonQuestions()}
          {getTopicList()}
        </ul>
      );
    }
    return null;
  };
  return renderTopicTree();
};

function mapStateToProps(state) {
  return {
    isLoading: state.topicList.isLoading,
    topics: state.topicList.topics,
    location: state.location,
    error: state.topicList.error,
    article: state.article.article,
    breadcrumb: state.breadcrumb.items,
  };
}
TopicList.propTypes = {
  topics: PropTypes.arrayOf(PropTypes.shape({
    topicId: PropTypes.string,
    topicName: PropTypes.string,
  })),
  isLoading: PropTypes.bool,
  error: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
};

TopicList.defaultProps = {
  topics: [],
  display: false,
  location: undefined,
};
export default connect(mapStateToProps)(TopicList);



// WEBPACK FOOTER //
// ./home/containers/TopicList.js